import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_COMMUNICATION {
  ID_RACCOMANDATA = '1',
  ID_ALTRO_MEZZO = '2',
}

const dataList = Object.freeze([
  {
    id: ID_COMMUNICATION.ID_RACCOMANDATA,
    value: 'Raccomandata AR',
  },
  {
    id: ID_COMMUNICATION.ID_ALTRO_MEZZO,
    value: 'Altro mezzo di comunicazione',
  },
]);

interface ListCommunicationProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label?: string;
}

const ListCommunicationComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  label = 'Modalità di comunicazione',
}: ListCommunicationProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${label}-label`}>
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId={`${label}-label`}
        id={label}
        name={label}
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {dataList.map((number: ItemVM) => (
          <MenuItem key={number.id} value={number.id}>
            {number.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListCommunicationComponent.displayName = 'List Communication component';

const ListCommunication = memo(ListCommunicationComponent);

export default ListCommunication as typeof ListCommunicationComponent;
